export const revJetConfig = {
  qa: {
    tag: 'tag153737',
    plc_id: '47147873',
    key: 'b80',
    path: 'https://rma.homedepotdev.com/bg'
  },
  prod: {
    tag: 'tag78602',
    plc_id: '17222446',
    key: 'bd6',
    path: 'https://rma.homedepot.com/bg'
  }
};